import { useMutation } from "@apollo/client/react";

import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import moment from 'moment';
import { VALIDATE_CONTRATO } from "../../../data/graphQL/mutations/Contratos/validateContrato";
import { VALIDATE_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ValidateRI";
import { REASIGNAR_PROFESIONAL_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ReasignarProfesionalRI";
import { CREATE_MIS_TAREAS } from "../../../data/graphQL/mutations/ResumenIngresoValidation/CreateMisTareas";
import { datosGeneralesModel } from "../constants/datosGeneralesModel";
import { CAMBIAR_PROGRAMA_EVALUACION } from "../../../data/graphQL/mutations/ResumenIngresoValidation/CambiarProgramaEvaluacion";

export const useGetActions = ({ handleChange, isReasignacion, notification }) => {
  const navigate = useNavigate();

  const [validateContrato] = useMutation(VALIDATE_CONTRATO, {
    variables: {
      idEvaluacion: notification?.idEvaluacion
    }
  });


  const [validarRI, { loading: validateLoading }] = useMutation(VALIDATE_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success("Se ejecutó la validación correctamente!");
    }
  });

  const [asignarProfesional, { loading: asignarLoading }] = useMutation(CREATE_MIS_TAREAS, {
    onCompleted: () => {
      toast.success('Se asignó al profesional correctamente!');
    }
  });

  const [reAsignarProfesional, { loading: reasignarLoading }] = useMutation(REASIGNAR_PROFESIONAL_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success('Se reasignó al profesional correctamente!');
    }
  });

  const [cambiarPrograma, { loading: cambiarProgramaLoading }] = useMutation(CAMBIAR_PROGRAMA_EVALUACION, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success('Se cambió el programa correctamente!');
    }
  });

  const handleClickValidar = (rechazo) => {
    validarRI({
      variables: {
        input: {
          idEvaluacion: notification?.idEvaluacion,
          idMotivoRechazo: rechazo?.idMotivoRechazo,
          observacion: rechazo?.observacion,
          tipoNotificacion: "RESUMEN_INGRESO",
          requiereIndicacion: false
        }
      }
    }).then(() => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);

      if (rechazo?.idMotivoRechazo)
        validateContrato();

    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  const handleClickAsignar = (row) => {
    if (asignarLoading || reasignarLoading) return;
    
    const nombreCompleto = row.nombre + ' ' + row.apellido;
    handleChange('profesionalASignado', nombreCompleto);

    const variables = isReasignacion ?
      {
        input: {
          idProfesional: row?.codigoProfesional,
          idDatosGeneralesRI: notification?.idDatosGenerales,
          fechaLimite: notification?.fechaLimite,
          idEvaluacion: notification?.idEvaluacion
        }
      } :
      {
        input: {
          idProfesional: row?.codigoProfesional,
          fechaLimite: moment().add(2, 'd').format('yyyy-MM-DD HH:mm'),
          datosGeneralesRI: {
            idPaciente: notification?.hC,
            cod_Cliente: notification.codSap,
            tiposModulos: [notification.idTipoModulo],
            ...datosGeneralesModel
          },
          idEvaluaciones: [notification.idEvaluacion]
        }
      };

    const mutation = isReasignacion ? reAsignarProfesional : asignarProfesional;

    mutation({ variables }).
      then(() => {
        navigate('/asignacionValidacionResumenIngreso');
      }).
      catch(() => toast.error('Ha ocurrido un error al asignar!'));
  };


  const handleClickCambiarPrograma = () => {
    cambiarPrograma({
      variables: {
        idEvaluacion: notification?.idEvaluacion,
        tipoNotificacionAsistencial: "RESUMEN_INGRESO"
      }
    }).then((res) => {

      if (!res?.data?.cambiarProgramaContrato?.success)
        toast.error(res?.data?.cambiarProgramaContrato?.error || 'Ha ocurrido un error!');
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  return {
    handleClickValidar,
    handleClickAsignar,
    handleClickCambiarPrograma,
    loading: validateLoading || asignarLoading || reasignarLoading || cambiarProgramaLoading
  };
};